
export const getIsSaveConsultation = ( state ) => {
 return state.save
}



